import { GraphQL } from "@rpi/openapi-api";
import { Flex } from "@rpi/openapi-core";
import React from "react";
import { Body } from "../../../components/Typography";
import { fmtEmail, fmtFullName } from "../../../utils/format.util";
import { dashboardUserRoleRender } from "../../../utils/searchField.util";
import { AccountSettingsCard } from "./AccountSettingsCard";
import { FieldFrame } from "./FieldFrame";
import { FieldRow } from "./FieldRow";
import { LabeledField } from "./LabeledField";

type DashboardUser = GraphQL.DashboardUserCurrentQuery["dashboardUserCurrent"];

const MASKED_PASSWORD = "************";

function nameWithUsername(user: DashboardUser): string {
  const fullName = fmtFullName(user);
  return user.username ? `${fullName} (${user.username})` : fullName;
}

interface AccountInformationCardProps {
  dashboardUser: DashboardUser;
  onEdit: () => void;
}

export const AccountInformationCard: React.FC<AccountInformationCardProps> = ({ dashboardUser, onEdit }) => (
  <AccountSettingsCard title="Account Information" onEdit={onEdit} data-testid="account-information-card">
    <FieldFrame>
      <Flex.Column gap={2}>
        <Body size="lg" weight="bold" data-testid="account-information-name">
          {nameWithUsername(dashboardUser)}
        </Body>
        {dashboardUser.role && (
          <Body data-testid="account-information-role">{dashboardUserRoleRender(dashboardUser.role)}</Body>
        )}
      </Flex.Column>

      <FieldRow>
        <LabeledField label="Email" value={fmtEmail(dashboardUser)} testId="account-information-email" />
        <LabeledField label="Password" value={MASKED_PASSWORD} />
      </FieldRow>
    </FieldFrame>
  </AccountSettingsCard>
);
